export const NR_CUSTOMATTRIBUTE_SHOPPING_LIST_ID = 'listId';
export const NR_CUSTOMATTRIBUTE_SHOPPING_LIST_TYPE = 'listType';
export const NR_CUSTOMATTRIBUTE_SHOPPING_LIST_NUM_PRODUCTS = 'numberOfProducts';
